const richTextLinkToLinkObject = (props) => ({
  ...(props || {}),
  url: props?.href,
  cached_url: props?.href
});

export { richTextLinkToLinkObject }
